"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAsyncReportResponseToJSON = exports.CreateAsyncReportResponseFromJSONTyped = exports.CreateAsyncReportResponseFromJSON = exports.instanceOfCreateAsyncReportResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateAsyncReportResponse interface.
 */
function instanceOfCreateAsyncReportResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateAsyncReportResponse = instanceOfCreateAsyncReportResponse;
function CreateAsyncReportResponseFromJSON(json) {
    return CreateAsyncReportResponseFromJSONTyped(json, false);
}
exports.CreateAsyncReportResponseFromJSON = CreateAsyncReportResponseFromJSON;
function CreateAsyncReportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
    };
}
exports.CreateAsyncReportResponseFromJSONTyped = CreateAsyncReportResponseFromJSONTyped;
function CreateAsyncReportResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
exports.CreateAsyncReportResponseToJSON = CreateAsyncReportResponseToJSON;
